// https://github.com/logzio/gaia-full/blob/master/log-analytics/structure-analyzer/client/src/main/kotlin/io/logz/structure/analyzer/responses/AccountStructureResponse.kt
export class AccountStructureModel {
    signature;
    logType;
    logSizeInBytes;
    previousLogSize;
    planUsagePercentage;
    docCount;
    sampleLog;
}
//# sourceMappingURL=logs-structures.js.map